import React, { useState } from 'react';
import './HowItWorksPopup.css';

const STORAGE_KEY = 'howItWorksSeen';

const HowItWorksPopup = () => {
  const [visible, setVisible] = useState(() => !localStorage.getItem(STORAGE_KEY));

  if (!visible) return null;

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  return (
    <div className="hiw-overlay">
      <div className="hiw-card">

        <div className="hiw-left">
          <div className="hiw-header desktop-title">
            <h1>How It Works</h1>
          </div>
          <div className="hiw-body">
            <p>We want you to join our Disney hideaway as easily as possible, so here's a lil explanation:</p>

            <h2>THINGS TO KNOW ABOUT OUR WEBSITE</h2>

            <p>We post <strong>ONE week per month!</strong> We source from the parks through the month and post out from the UK last week of each month!<br />
            To manage posting expectations, please check the countdown on the page.</p>

            <h3>Your order remains OPEN!</h3>
            <p>The countdown tells you how long you can add to your order for in the current month!<br />
            Yes, <em>add</em> to your order! So you can save on postage.</p>

            <p><strong>Add to order by checking out as normal.</strong><br />
            No extra steps, just cheaper postage!</p>

            <h3>How to order?</h3>
            <p>There are three ways to order:</p>

            <p><strong>Order something that is already on the site!</strong><br />
            Your usual shopping experience with a little added magic.</p>

            <p><strong>Pre-order something already on the site.</strong><br />
            These are items we expect to be in stock/be able to source and will collect as ordered!</p>

            <p><strong>Request an item</strong><br />
            Possibly the juiciest part of the services we offer.<br />
            Go to our make a request page and tell us what you're looking for!</p>

            <p>We will find the price and email you a cart to checkout as normal. Don't worry, you will be able to review the price before ordering so the choice is totally yours!</p>

            <p>We will gather all your items and post them out at the end of the month. Once the countdown is complete, your order will be closed and you will no longer be able to add to it for the current month.<br />
            Any new purchases will open an order for the following month and postage will be recalculated based on the new order.</p>

            <p>We use <strong>Royal Mail</strong> for UK and US orders.</p>

            <p>Any more questions? Check out the <a href="/contact">contact us page</a>!</p>

            <p className="hiw-sign-off">We can't wait to deliver you magic! Thank you for the support ♡</p>
          </div>

          <div className="hiw-footer">
            <button className="btn-magic" onClick={handleClose}>Let's go!</button>
          </div>
        </div>

        <div className="hiw-right">
          <div className="hiw-mobile-title">
            <h1>How It Works</h1>
          </div>
        </div>

      </div>
    </div>
  );
};

export default HowItWorksPopup;
